module.exports = __webpack_public_path__ + "img/extraction.0bcd0e2c.svg";